/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { GoogleMap, Marker, InfoWindow, MarkerClusterer } from '@react-google-maps/api';

const ViewAllWaypointsWithCluster = ({
  isOpen,
  setIsOpen,
  waypoints = [],
  isLoaded, 
}) => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const mapRef = useRef(null);

  const closeModal = () => setIsOpen(false);



  if (!isLoaded) return 'Loading Map...';

  return (
    <Modal
      style={{ top: 100 }}
      width={900}
      open={isOpen}
      onCancel={closeModal}
      footer={null}
      closable={false}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h4>All Waypoints</h4>
          <CloseOutlined
            style={{ fontSize: '1.5em', cursor: 'pointer' }}
            onClick={closeModal}
          />
        </div>
      }
    >
<GoogleMap
  mapContainerStyle={{ height: '700px', width: '100%', borderRadius: '16px' }}
  zoom={11} 
  center={{ lat: 35.9375, lng: 14.3754 }} 
  onLoad={(map) => { mapRef.current = map; }}
  options={{ disableDefaultUI: true, zoomControl: true }}
>

        <MarkerClusterer>
          {(clusterer) =>
            waypoints.map((wp) => (
              <Marker
                key={wp.id}
                position={{ lat: Number(wp.latitude), lng: Number(wp.longitude) }}
                clusterer={clusterer}
                icon={{ url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' }}
                onClick={() => setSelectedMarker(wp)}
              />
            ))
          }
        </MarkerClusterer>

        {selectedMarker && (
          <InfoWindow
            position={{
              lat: Number(selectedMarker.latitude),
              lng: Number(selectedMarker.longitude),
            }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div>
              <h3>{selectedMarker.locationName}</h3>
              <p>ID: {selectedMarker.id}</p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </Modal>
  );
};

export default ViewAllWaypointsWithCluster;
